import axios from "axios";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Back from "../components/button/back";

const AddUser = () => {
  const navigate = useNavigate();
  const [previewUrl, setPreviewUrl] = useState(null);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    role: "",
    NISN: "",
    NIPD: "",
    NIP: "",
    statusPPH: "",
    jabatan: "",
    name: "",
    kelamin: "",
    Agama: "",
    TL: "",
    TGL: "",
    Alamat: "",
    anakke: "",
    ayah: "",
    ibu: "",
    wali: "",
    Payah: "",
    Pibu: "",
    Pwali: "",
    SekolahAsal: "",
    kelas: "",
    rombel: "",
    mapel: "",
    image: "", // nanti diisi filename
  });

  const [file, setFile] = useState(null);
  const [usernameExists, setUsernameExists] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setUsernameExists(false);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    if (selectedFile) {
      setPreviewUrl(URL.createObjectURL(selectedFile));
    }
  };

  const handleImageUpload = async () => {
    if (!file) return "";

    const imageData = new FormData();
    imageData.append("image", file);

    // Hanya tambahkan oldFileId jika kamu sedang mengupdate user
    // Tidak perlu saat register user baru
    // if (formData.image && formData.image.fileId) {
    //   imageData.append("oldFileId", formData.image.fileId);
    // }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}api/auth/upload`,
        imageData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      return response.data.image; // { fileId, filename, mimetype }
    } catch (error) {
      console.error("Error uploading image:", error);
      return "";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const imageData = await handleImageUpload();
    if (imageData) {
      formData.image = imageData; // simpan object lengkap
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}api/auth/register`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      toast.success("User berhasil ditambahkan!");
      navigate(`/admin/add-user`);
    } catch (error) {
      if (
        error.response?.status === 400 &&
        error.response?.data?.msg === "User already exists"
      ) {
        setUsernameExists(true);
        toast.error("Username sudah digunakan. Silakan coba yang lain.");
      } else {
        console.error("Error adding user:", error);
        toast.error("Terjadi kesalahan. Coba lagi.");
      }
    }
  };

  return (
    <div className="grid justify-center min-h-screen bg-blue-100">
      <ToastContainer />
      <div>
        <div className="flex justify-center my-10">
          <h2 className="font-bold text-3xl">Add User</h2>
        </div>

        <div className="bg-white p-5 rounded-lg w-[400px] md:w-[600px]">
          <form
            onSubmit={handleSubmit}
            className="grid ring-1 ring-slate-500/20 rounded-md p-5 gap-y-5"
          >
            {usernameExists && (
              <div className="text-red-500">
                Username sudah digunakan. Silakan gunakan username lain.
              </div>
            )}
            {/* ROLE */}
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              required
              className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
            >
              <option value="">Pilih Role</option>
              <option value="admin">Admin</option>
              <option value="guru">Guru</option>
              <option value="siswa">Siswa</option>
            </select>
            {/* Username & Password */}
            <input
              type="text"
              name="username"
              placeholder="Username"
              onChange={handleChange}
              className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
              required
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              onChange={handleChange}
              className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
              required
            />
            <input
              type="text"
              name="name"
              placeholder="Nama Lengkap"
              onChange={handleChange}
              className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
              required
            />
            <select
              name="kelamin"
              value={formData.kelamin}
              onChange={handleChange}
              required
              className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
            >
              <option value="">Pilih Jenis Kelamin</option>
              <option value="Laki-laki">Laki-laki</option>
              <option value="Perempuan">Perempuan</option>
            </select>
            <input
              type="text"
              name="TL"
              placeholder="Tempat Lahir"
              onChange={handleChange}
              className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
              required
            />{" "}
            <p>Tanggal Lahir</p>
            <input
              type="date"
              name="TGL"
              placeholder="Tanggal Lahir"
              onChange={handleChange}
              className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
              required
            />
            <select
              name="Agama"
              value={formData.Agama}
              onChange={handleChange}
              required
              className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
            >
              <option value="">Pilih Agama</option>
              <option value="Islam">Islam</option>
              <option value="Kristen Protestan">Kristen Protestan</option>
              <option value="Kristen Katolik">Kristen Katolik</option>
              <option value="Hindu">Hindu</option>
              <option value="Buddha">Buddha</option>
              <option value="Konghucu">Konghucu</option>
            </select>
            {/* Role Siswa */}
            {formData.role === "siswa" && (
              <>
                <input
                  type="text"
                  name="NISN"
                  placeholder="NISN"
                  onChange={handleChange}
                  className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                />
                <input
                  type="text"
                  name="NIPD"
                  placeholder="NIPD"
                  onChange={handleChange}
                  className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                />
                <select
                  name="kelas"
                  value={formData.kelas}
                  onChange={handleChange}
                  required
                  className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                >
                  <option value="">Pilih Kelas</option>
                  {[1, 2, 3, 4, 5, 6].map((kelas) => (
                    <option key={kelas} value={kelas}>
                      {kelas}
                    </option>
                  ))}
                </select>
                <select
                  name="rombel"
                  value={formData.rombel}
                  onChange={handleChange}
                  required
                  className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                >
                  <option value="">Pilih Rombel</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                </select>
                <p>Tanggal diterima disekolah</p>
                <input
                  type="date"
                  name="TGLditerima"
                  placeholder="Tanggal Diterima"
                  onChange={handleChange}
                  className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                />
                <input
                  type="text"
                  name="SekolahAsal"
                  placeholder="Sekolah Asal (Jika Pindah sekolah)"
                  onChange={handleChange}
                  className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                />
                <input
                  type="text"
                  name="Alamat"
                  placeholder="Alamat Peserta didik"
                  onChange={handleChange}
                  className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                />
                <input
                  type="text"
                  name="anakke"
                  placeholder="Anaka ke -"
                  onChange={handleChange}
                  className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                />
                <input
                  type="text"
                  name="ayah"
                  placeholder="Nama Lengkap Ayah"
                  onChange={handleChange}
                  className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                />
                <select
                  name="Payah"
                  value={formData.Payah}
                  onChange={handleChange}
                  className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                >
                  <option value="">Pekerjaan</option>
                  <option value="PNS/TNI/Polri">PNS/TNI/Polri</option>
                  <option value="Swasta">Swasta</option>
                  <option value="Wiraswasta/wirausaha">
                    {" "}
                    Wiraswasta/wirausaha
                  </option>
                  <option value="Lainnya"> Lainnya</option>
                </select>
                <input
                  type="text"
                  name="ibu"
                  placeholder="Nama Lengkap Ibu"
                  onChange={handleChange}
                  className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                />
                <select
                  name="Pibu"
                  value={formData.Pibu}
                  onChange={handleChange}
                  className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                >
                  <option value="">Pekerjaan</option>
                  <option value="PNS/TNI/Polri">PNS/TNI/Polri</option>
                  <option value="Swasta">Swasta</option>
                  <option value="Wiraswasta/wirausaha">
                    {" "}
                    Wiraswasta/wirausaha
                  </option>
                  <option value="Lainnya"> Lainnya</option>
                </select>
                <input
                  type="text"
                  name="wali"
                  placeholder="Nama Lengkap Wali"
                  onChange={handleChange}
                  className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                />
                <select
                  name="Pwali"
                  value={formData.Pwali}
                  onChange={handleChange}
                  className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                >
                  <option value="">Pekerjaan</option>
                  <option value="PNS/TNI/Polri">PNS/TNI/Polri</option>
                  <option value="Swasta">Swasta</option>
                  <option value="Wiraswasta/wirausaha">
                    {" "}
                    Wiraswasta/wirausaha
                  </option>
                  <option value="Lainnya"> Lainnya</option>
                </select>
              </>
            )}
            {/* Role Guru */}
            {formData.role === "guru" && (
              <>
                <select
                  name="statusPPH"
                  value={formData.statusPPH}
                  onChange={handleChange}
                  className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                >
                  <option value="">Pilih Status</option>
                  <option value="PNS">PNS</option>
                  <option value="PPPK">PPPK</option>
                  <option value="Honorer">Honorer</option>
                </select>
                <input
                  type="text"
                  name="NIP"
                  placeholder="NIP"
                  onChange={handleChange}
                  className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                />
                <select
                  name="jabatan"
                  value={formData.jabatan}
                  onChange={handleChange}
                  className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                >
                  <option value="">Pilih Jabatan</option>
                  <option value="Kepala Sekolah">Kepala Sekolah</option>
                  <option value="Guru Kelas">Guru Kelas</option>
                  <option value="Guru Mapel">Guru Mapel</option>
                </select>

                {formData.jabatan === "Guru Kelas" && (
                  <>
                    <select
                      name="kelas"
                      value={formData.kelas}
                      onChange={handleChange}
                      required
                      className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                    >
                      <option value="">Pilih Kelas</option>
                      {[1, 2, 3, 4, 5, 6].map((kelas) => (
                        <option key={kelas} value={kelas}>
                          {kelas}
                        </option>
                      ))}
                    </select>
                    <select
                      name="rombel"
                      value={formData.rombel}
                      onChange={handleChange}
                      required
                      className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                    >
                      <option value="">Pilih Rombel</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                      <option value="D">D</option>
                    </select>
                  </>
                )}

                {formData.jabatan === "Guru Mapel" && (
                  <select
                    name="mapel"
                    value={formData.mapel}
                    onChange={handleChange}
                    required
                    className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
                  >
                    <option value="">Pilih Mata Pelajaran</option>
                    {[
                      "IPA",
                      "IPS",
                      "MTK",
                      "BIndo",
                      "BIng",
                      "PAI",
                      "PKN",
                      "IPAS",
                      "PJOK",
                      "MULOK",
                      "Senibudaya",
                    ].map((m) => (
                      <option key={m} value={m}>
                        {m}
                      </option>
                    ))}
                  </select>
                )}
              </>
            )}
            {/* Nama & Data Umum */}
            {/* Gambar */}
            <input
              type="file"
              name="image"
              onChange={handleFileChange}
              className="bg-transparent ring-1 ring-slate-500/20 py-2 px-2 rounded-lg"
            />
            {previewUrl && (
              <div className="mt-2">
                <img
                  src={previewUrl}
                  alt="Preview"
                  className="w-32 h-32 object-cover rounded border"
                />
              </div>
            )}
            {/* Submit */}
            <div className="flex justify-between items-center">
              <button
                type="submit"
                className="py-2 px-5 bg-indigo-600 text-white rounded-lg"
              >
                Add User
              </button>
            </div>
          </form>
          <div className="mx-5 mt-5">
            <Link to="/admin">
              <Back />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUser;
